import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import MovieCard from '@/components/feature/MovieCard';

export default function LatestUpdates() {
  const newMovies = movies.filter((m) => m.isNew).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">每日更新，精彩不停</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer transition-colors whitespace-nowrap"
          >
            更多新片 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {newMovies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}